import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { validateInit, validateForm } from '@assets/js/util/formValidation.js';
import { formAtt } from '@assets/js/util/commonUtil.js';
import CompFmtInput from '@components/form/fragment/comp-fmt-input.js';
import CompFmtSelectbox from '@components/form/fragment/comp-fmt-selectbox.js';

const CompFormMatchTrmnt = forwardRef((props, ref) => {
    const [params, setParams] = useState({});
    const [title, setTitle] = useState('토너먼트 등록/수정');
    const [dvsnParams, setDvsnParams] = useState({});
    const [wetclsParams, setWetclsParams] = useState([]);

    /****************************
     * Define required variables
    *****************************/
    const rootId = 'modalSheet';
    const validateOpt = {
        scopeEle: document.querySelector('#' + rootId),
        targetIds: ['comptnCd', 'dvsnCd', 'wetclsCd', 'armType', 'seedNo'],
        params: params,
    }

    /*************************
     * Define react functions
    **************************/
    // Forward ref to allow parent components to call event functions.
    useImperativeHandle(ref, () => ({
        modalToggle(p_params) {
            handleToggle();
            handleValue(p_params);
            setParams(p_params || {});
        },
    }));

    /**********************
     * Define functions
    ***********************/
    const handleValue = (p_params) => {
        const targetEle = document.querySelector('#' + rootId);

        // Handle mode-specific logic
        if (p_params && p_params.mode === 'M') {
            setTitle('토너먼트 상세');
            // Modify mode - disable primary key fields
            const comptnCdEle = targetEle?.querySelector('#comptnCd');
            const dvsnCdEle = targetEle?.querySelector('#dvsnCd');
            const wetclsCdEle = targetEle?.querySelector('#wetclsCd');
            const armTypeEle = targetEle?.querySelector('#armType');
            const seedNoEle = targetEle?.querySelector('#seedNo');

            if (comptnCdEle) comptnCdEle.disabled = true;
            if (dvsnCdEle) dvsnCdEle.disabled = true;
            if (wetclsCdEle) wetclsCdEle.disabled = true;
            if (armTypeEle) armTypeEle.disabled = true;
            if (seedNoEle) seedNoEle.disabled = true;

            setDvsnParams({comptnCd: p_params?.comptnCd});
            setWetclsParams({comptnCd: p_params?.comptnCd});
        } else {
            setTitle('토너먼트 등록');
            // Insert mode - enable all fields for selection
            const comptnCdEle = targetEle?.querySelector('#comptnCd');
            const dvsnCdEle = targetEle?.querySelector('#dvsnCd');
            const wetclsCdEle = targetEle?.querySelector('#wetclsCd');
            const armTypeEle = targetEle?.querySelector('#armType');
            const seedNoEle = targetEle?.querySelector('#seedNo');

            if (comptnCdEle) comptnCdEle.disabled = false;
            if (dvsnCdEle) {
                dvsnCdEle.disabled = false;
                setDvsnParams({});
            }
            if (wetclsCdEle) {
                wetclsCdEle.disabled = false;
                setWetclsParams({});
            }
            if (armTypeEle) armTypeEle.disabled = false;
            if (seedNoEle) seedNoEle.disabled = false;
        }
    }

    const handleToggle = () => {
        const targetEle = document.querySelector('#' + rootId);
        if (targetEle) {
            targetEle.style.display = targetEle.style.display === 'none' ? 'block' : 'none';
        }

        // Reset form inputs and validation state
        validateInit(validateOpt);

        Object.keys(formObj).forEach(key => {
            const ele = targetEle?.querySelector(`#${formObj[key].id}`);
            if (ele) { ele.value = ''; }
        });
    }

    // const onSave = () => {
    //     // Validate form inputs before saving
    //     if (!validateForm(validateOpt)) { return; }
    //     if (params == null || params.mngCd === '' || params.comptnCd === '') { return; }

    //     console.log('Saving match tournament data:', params);

    //     // Create mtmkgCd from individual codes
    //     const mtmkgCd = `${params.comptnCd || ''}-${params.dvsnCd || ''}-${params.wetclsCd || ''}`;
    //     const saveParams = {
    //         ...params,
    //         mtmkgCd: mtmkgCd
    //     };

    //     // Fetch data from the server
    //     ApiSave('/sys/matchtrmntmng/save/info', saveParams).then(res => {
    //         // Close the modal after saving
    //         handleToggle();
    //         // Search for updated data
    //         props.onGridSearch();
    //     });
    // }

    const onValChange = (e) => {
        const { id } = e.target;
        // Validate the specific input field
        validateForm(validateOpt, id);
    }

    const onInputChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value only (no validation)
        setParams({ ...params, [id]: value });
    }

    // Handle competition code change - fetch related division and weight class data
    const onComptnCdChange = (e) => {
        const { id, value } = e.target;
        setParams({ ...params, [id]: value, dvsnCd: '', wetclsCd: '' });

        if (value) {
            // Fetch division and weight class options for selected competition
            setDvsnParams({comptnCd: value});
            setWetclsParams({comptnCd: value});
        } else {
            // Clear Params if no competition selected
            setDvsnParams({});
            setWetclsParams({});
        }
    }

    const onChangeMtmkg = (e) => {
        const { id, value } = e.target;
        const rootEle = document.getElementById(rootId);

        // Get competition code
        const comptnCdElement = rootEle.querySelector('#comptnCd');
        const comptnCd = comptnCdElement ? comptnCdElement.value : '';

        // Get selected option text for wetclsCd
        const wetclsCdElement = rootEle.querySelector('#wetclsCd');
        const wetclsCd = wetclsCdElement ? wetclsCdElement.value : '';

        // Get selected option text for dvsnCd
        const dvsnCdElement = rootEle.querySelector('#dvsnCd');
        const dvsnCd = dvsnCdElement ? dvsnCdElement.value : '';

        // Create mtmkgCd from individual codes
        const mtmkgCd = comptnCd && dvsnCd && wetclsCd ? `${comptnCd}-${dvsnCd}-${wetclsCd}` : '';

        setParams({ ...params, [id]: value, mtmkgCd: mtmkgCd });
    }

    /****************************
     * Define form config
    *****************************/
    // Dynamic form configuration based on mode
    const formObj = {
        // Top section - Code selectors (dynamic disabled based on mode)
        comptnCd : formAtt({id: 'comptnCd', label: '대회', value: params['comptnCd'] || '', disabled: true, required: true, classCol: 'col-8'}),
        dvsnCd   : formAtt({id: 'dvsnCd', label: '부문', value: params['dvsnCd'] || '', disabled: true, required: true, classCol: 'col-4'}),
        wetclsCd : formAtt({id: 'wetclsCd', label: '체급', value: params['wetclsCd'] || '', disabled: true, required: true, classCol: 'col-4'}),
        armType  : formAtt({id: 'armType', label: '팔 유형', value: params['armType'] || '', disabled: true, required: true, classCol: 'col-4'}),

        // Tournament specific fields
        seedNo   : formAtt({id: 'seedNo', label: '시드', value: params['seedNo'] || '', disabled: true, required: true, classCol: 'col-6'}),
        seedType : formAtt({id: 'seedType', label: '시드타입', value: params['seedType'] || '', disabled: true, required: true,classCol: 'col-6'}),
        plyrCdA  : formAtt({id: 'plyrCdA', label: '선수A', value: params['plyrCdA'] || '', disabled: true, classCol: 'col-6'}),
        plyrCdB  : formAtt({id: 'plyrCdB', label: '선수B', value: params['plyrCdB'] || '', disabled: true, classCol: 'col-6'}),
        winPlyr  : formAtt({id: 'winPlyr', label: '승자', value: params['winPlyr'] || '', disabled: true, classCol: 'col-6'}),
        losePlyr : formAtt({id: 'losePlyr', label: '패자', value: params['losePlyr'] || '', disabled: true, classCol: 'col-6'}),
        mtmkgStat: formAtt({id: 'mtmkgStat', label: '대진상태', value: params['mtmkgStat'] || '', disabled: true, required: true, classCol: 'col-4'}),
    }

    return (
        <>
            <div
                className="modal modal-sheet p-1 py-md-5"
                style={{ display: 'none', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
                tabIndex={-1}
                role="dialog"
                id={rootId}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content rounded-4 shadow">
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-5">{title}</h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleToggle}
                            />
                        </div>
                        <div className="modal-body py-0">
                            <div className="row g-5">
                                <div className="col-lg-12">
                                    <form className="needs-validation" noValidate="">
                                        <div className="row">
                                            {/* Top section: Code selectors */}
                                            <div className="col-12">
                                                <div className="bg-light p-3 rounded mb-3">
                                                    <div className="row mb-3">
                                                        <CompFmtSelectbox
                                                            attrs={formObj.comptnCd}
                                                            grpCd={"COMPT"}
                                                            selectType={"S"}
                                                            onChange={onComptnCdChange}
                                                        />
                                                        <CompFmtSelectbox
                                                            attrs={formObj.mtmkgStat}
                                                            grpCd={"GRP007"}
                                                            selectType={"S"}
                                                            onChange={onInputChange}
                                                        />
                                                    </div>
                                                    <div className="row mb-3">
                                                        <CompFmtSelectbox
                                                            attrs={formObj.dvsnCd}
                                                            grpCd={"DVSNCD"}
                                                            selectType={"S"}
                                                            customParams={dvsnParams}
                                                            onChange={onChangeMtmkg}
                                                        />
                                                        <CompFmtSelectbox
                                                            attrs={formObj.wetclsCd}
                                                            grpCd={"WETCLSCD"}
                                                            selectType={"S"}
                                                            customParams={wetclsParams}
                                                            onChange={onChangeMtmkg}
                                                        />
                                                        <CompFmtSelectbox
                                                            attrs={formObj.armType}
                                                            grpCd={"GRP005"}
                                                            selectType={"S"}
                                                            onChange={onInputChange}
                                                        />
                                                    </div>
                                                    <div className="row mb-3">
                                                        <CompFmtInput
                                                            attrs={formObj.seedNo}
                                                            onChange={onInputChange}
                                                            onBlur={onValChange}
                                                        />
                                                        <CompFmtSelectbox
                                                            attrs={formObj.seedType}
                                                            grpCd={"GRP006"}
                                                            selectType={"S"}
                                                            onChange={onInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Tournament specific fields */}
                                            <CompFmtInput
                                                attrs={formObj.plyrCdA}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.plyrCdB}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.winPlyr}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.losePlyr}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex-column align-items-stretch w-100 gap-2 pb-3 border-top-0">
                            <button type="button" className="btn btn-lg btn-secondary" data-bs-dismiss="modal" onClick={handleToggle}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default CompFormMatchTrmnt;
